import { HotelCardActionPropertiesType } from "@website/accommodation-ui/hotel-card-new/hotel-card-action/hotel-card-action.types";
import { HotelCardPricing } from "@website/accommodation-ui/hotel-card-new/hotel-card-action/hotel-card-pricing";
import { HotelCardReservationInfo } from "@website/accommodation-ui/hotel-card-new/hotel-card-action/hotel-card-reservation-info";
import { HotelCardLink } from "@website/accommodation-ui/hotel-card-new/hotel-card-link";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { FC, memo } from "react";

const Component: FC<HotelCardActionPropertiesType> = (properties) => {
  const {
    clickLoading,
    pricingInfo,
    roomTitle,
    reservationInfo,
    roomCount,
    isFomo,
    size = "responsive",
    isAvailable,
    loading,
    linkProperties,
    isLanding,
    hasSnappProDiscount
  } = properties;
  const router = useRouter();

  return (
    <div
      className={
        size === "small"
          ? "flex shrink-0 flex-col items-stretch justify-between"
          : `flex w-full flex-row flex-wrap items-stretch justify-between md:h-full ${
              size === "medium"
                ? "max-w-[161px]"
                : "md:min-w-[200px] lg:max-w-[213px]"
            } md:flex-col md:flex-nowrap md:justify-end md:ps-4 lg:shrink-0 lg:ps-0`
      }
    >
      {isAvailable ? (
        <>
          <div className="flex flex-1 flex-col justify-center">
            {isFomo && !loading && size !== "xSmall" && (
              <div
                className={`mt-2 flex h-auto items-center gap-1 md:mt-0 lg:justify-center lg:pb-6 ${
                  size === "small" ? "mt-2 !pb-2 md:mt-0 md:!justify-start" : ""
                }`}
              >
                <MaterialIcon
                  className="text-error text-sm lg:text-base"
                  name="info"
                  variant="outlined"
                />
                <span
                  className="text-caption text-on-surface-high-emphasis truncate"
                  data-testid="hotel_card_room_count"
                >
                  <span className="text-error">{`فقط ${numberConvert(
                    roomCount,
                    {
                      numberOnly: false,
                      locale: router.locale || "fa"
                    }
                  )} اتاق باقی مانده`}</span>
                </span>
              </div>
            )}
            <div
              // eslint-disable-next-line tailwindcss/no-custom-classname
              className={`hotel-card-pricing flex w-full flex-row items-center justify-between pt-2 md:pt-0 ${
                !isFomo && "lg:flex-1 lg:justify-center"
              } ${
                size === "small" ? "lg:justify-between" : "lg:flex-col lg:gap-2"
              }`}
            >
              <HotelCardReservationInfo
                {...reservationInfo}
                roomTitle={roomTitle}
                size={size}
                isLanding={isLanding}
              />
              <HotelCardPricing
                {...pricingInfo}
                nightCount={reservationInfo?.nightCount}
                size={size}
                hasSnappProDiscount={hasSnappProDiscount}
              />
            </div>
          </div>
          <HotelCardLink
            {...linkProperties}
            className={`mt-3 w-full ${
              size === "small" ? "md:hidden" : "md:mt-6"
            }`}
          >
            <Button
              // eslint-disable-next-line tailwindcss/no-custom-classname
              className={"hotel-card-cta"}
              divButtonType
              fullWidth
              loading={clickLoading && router?.query?.["modal"] !== "review"}
            >
              {["villa"].includes(process.env.NEXT_PUBLIC_APP_NAME ?? "")
                ? "مشاهده اقامتگاه و رزرو"
                : " مشاهده اتاق‌ها و رزرو"}
            </Button>
          </HotelCardLink>
        </>
      ) : (
        <div className="flex size-full flex-col items-center">
          <div className="flex h-full flex-row items-center justify-center gap-3 pb-3 lg:flex-col lg:pb-0">
            <span className="text-body-2 text-error font-bold">
              تکمیل ظرفیت
            </span>
            <div className="text-caption flex flex-row gap-1">
              <MaterialIcon name="info" variant="outlined" />
              <span>تاریخ دیگری را بررسی کنید</span>
            </div>
          </div>
          <div className="w-full">
            <HotelCardLink
              {...linkProperties}
              className={`mt-3 w-full ${
                size === "small" ? "md:hidden" : "md:mt-6"
              }`}
            >
              <Button
                color="neutral"
                divButtonType
                fullWidth
                loading={clickLoading}
                loadingColor="primary"
                text={`مشاهده ${
                  ["villa"].includes(process.env.NEXT_PUBLIC_APP_NAME ?? "")
                    ? "اقامتگاه"
                    : "هتل"
                }  `}
                variant="outline"
              />
            </HotelCardLink>
          </div>
        </div>
      )}
    </div>
  );
};

export const HotelCardAction = memo(Component, deepCompare);
